import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Toaster } from 'ngx-toast-notifications';
import { Subscription } from 'rxjs';
import { delay, distinctUntilChanged, map, retryWhen } from 'rxjs/operators';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from '../../../environments/environment';
import { FeatureFlagService } from '../../feature-flag.service';
import { LanguageService } from '../../language.service';
import { NotificationsSidenavService } from '../../services/notifications-sidenav.service';
import { VehiclesFlowNotificationService } from '../../services/vehicles-flow.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  public subject: WebSocketSubject<any> | null = null;
  public vehiclesSubject: WebSocketSubject<any> | null = null;

  private _socketsMessageSub: Subscription;
  private _socketsVehiclesMessageSub: Subscription;
  private _translation: Subscription;

  public sensorNotifications: any;

  private ws: string;
  private vehiclesWs: string;

  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement;

  toasterMessage: string = '';
  toasterCaption: string = '';

  plateNmr: string = '';
  constructor(
    private translate: TranslateService,
    private languageService: LanguageService,
    private router: Router,
    private notificationsSidenavService: NotificationsSidenavService,
    private vehiclesFlowService: VehiclesFlowNotificationService,
    private toaster: Toaster,
    private featureFlagService: FeatureFlagService,
    @Inject(DOCUMENT) _document?: any) {

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = _document.body.classList.contains('sidebar-minimized');
    });
    this.element = _document.body;
    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });

    this.ws = `${environment.ws}/messages/all`
    this.vehiclesWs = `${environment.ws}/vehicleflow/all`

    // this.subject = webSocket('ws://localhost:3400');
    this.subject = webSocket(this.ws);
    this.vehiclesSubject = webSocket(this.vehiclesWs);
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this._socketsMessageSub = this.subject
      .pipe(
        retryWhen((errors) => errors.pipe(delay(20_000))),
        map(msg => {
          return msg['data']
        }))
      .subscribe(
        msg => {
          this.sensorNotifications = msg
          let type = msg.attributes.type
          this.toaster.open({
            caption: type.charAt(0).toUpperCase() + type.slice(1),
            text: `${msg.attributes.message} for sensor ${msg.attributes.sensor_id}`,
            type: `warning`,
            duration: 3200,
            position: "bottom-center"
          })
          this.notificationsSidenavService.setNewNotification(true);
          setTimeout(() => {
            this.notificationsSidenavService.setNewNotification(false);
          }, 500)
          this.notificationsSidenavService.transferNotifications(this.sensorNotifications)
        },
        err => console.log(err),
        () => {
        }
      );

    if (this.featureFlagService.featureOn('incoming-outgoing-vehicles')) {
      this._socketsVehiclesMessageSub = this.vehiclesSubject
        .pipe(
          retryWhen((errors) => errors.pipe(delay(20_000))),
          map(msg => {
            return msg['data']
          }))
        .subscribe(
          msg => {
            let type = msg.attributes.type

            this.plateNmr = msg.attributes.plate
            let incoming = false;
            incoming = msg.attributes.arrival != null && msg.attributes.departure == null ? !incoming : incoming
            this.getToasterTranslation(incoming)

            this.toaster.open({
              caption: this.toasterCaption,
              text: this.toasterMessage,
              type: msg.attributes.arrival != null && msg.attributes.departure == null ? `success` : `warning`,
              duration: 15000,
              position: "bottom-center"
            })
            this.vehiclesFlowService.setNewNotification(true);
            this.vehiclesFlowService.setNewNotification(false)
            this._translation.unsubscribe();
            this.toasterMessage = ''
            incoming = !incoming;
            // setTimeout(() => this.vehiclesFlowService.setNewNotification(false))

          },
          () => { }
        )
    }

  }

  getToasterTranslation(incoming: boolean) {
    this._translation = this.languageService.currentLanguage.pipe(distinctUntilChanged()).subscribe(res => {
      this.translate.get('INCOMING_OUTGOING_TOASTER_CAPTION', { plateNmr: this.plateNmr }).subscribe((s: string) => {
        this.toasterCaption = s;
      })
      if (incoming) {
        this.translate.get('INCOMING_VEHICLE', { plateNmr: this.plateNmr }).subscribe((s: string) => {
          this.toasterMessage = s;
        })
      } else {
        this.translate.get('OUTGOING_VEHICLE', { plateNmr: this.plateNmr }).subscribe((s: string) => {
          this.toasterMessage = s;
        })
      }
    })
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
    if (this._socketsMessageSub) this._socketsMessageSub.unsubscribe();
    if (this._socketsVehiclesMessageSub) this._socketsVehiclesMessageSub.unsubscribe();
  }
}
